import React, { useState, useEffect } from 'react';
import './SelectInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function SelectInput({ initialValue, showError, onSelect, onValidate, label, instructions, name, items, errorMessage, disabled, style, rules, size }) {
  const [value, setValue] = useState(initialValue ? initialValue : '');
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidation, setNeedsValidation] = useState(false);

  if (logComponent('SelectInput')) { console.debug('SelectInput rendered'); }

  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput onMount'); }
    if (value) validateThis();
  }, [])


  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [value]'); }
    if (showError) validateThis();
  }, [value])


  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [initialValue]'); }
    setValue(initialValue);
    setNeedsValidation(true);
  }, [initialValue])

  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [showError]'); }
    if (showError) validateThis();
  }, [showError])

  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [needsValidation]'); }
    if (needsValidation === true) {
      validateThis();
      setNeedsValidation(false);
    }
  }, [needsValidation])

  const updateValue = (e) => {
    if (logComponent('SelectInput')) { console.debug('SelectInput updateValue'); }
    setValue(e.target.value);
    setNeedsValidation(validateThis());

    if (onSelect) {
      onSelect(e.target.value);
    }
  }

  const validateThis = () => {
    if (logComponent('SelectInput')) { console.debug('SelectInput validateThis'); }

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](value, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    if (onValidate) {
      onValidate({
        name: name,
        isValid: isValidThis,
        value: value
      });
    }
  }
  const isObject = (val) => {
    return val instanceof Object;
  }
  const isNotObject = (val) => {
    return !( val instanceof Object)
  }
  const getOptionForItem = (item) => {
    let optionValue = item.value.toString();
    let optionKey = item.value.toString() + '_' + (item.key ?? '');
    let optionDescription = item.key ?? '';

    return <option value={optionValue} key={optionKey}>{optionDescription}</option>
  }
  const getOption = (item) => {
    if (isObject(item)) {
      let optionValue = item.value.toString();
      let optionKey = item.value.toString() + '_' + (item.key ?? '');
      let optionDescription = item.key ?? '';

      return <option value={optionValue} key={optionKey}>{optionDescription}</option>
    }
    else {
    }
    <option value={item} key={item}>{item}</option>
  }

  return (
    <div
      className="Select-Input-Group"
      style={style}>
      {
        showError && !isValid &&
        <p className="Select-Input-Group__error">{errorMessage}</p>
      }
      <label
        className="Select-Input-Group__label"
        htmlFor={name + '-input'}>
        {label}{
          rules && rules.required &&
          <span className="Select-Input-Group__required"> *</span>
        }
      </label>
      <select
        id={name + '-input'}
        className={'Select-Input-Group__select' + (size && size === 'small' ? ' Select-Input-Group__select--small' : '')}
        disabled={disabled}
        value={value}
        onBlur={validateThis}
        onChange={updateValue} >
        {
          items &&
          items.map((item,index) => {
            let valueOf = isObject(item) ? item.value.toString() : item;
            let keyOf = isObject(item) ? item.value.toString() + '_' + (item.key ?? '') : index;
            let textOf = isObject(item) ? item.key ?? '' : item;
            return <option value={valueOf} key={keyOf}>{textOf}</option>
          }
          )
        }
      </select>
      {
        instructions &&
        <span className="Text-Input-Group__instructions">{instructions}</span>
      }

    </div>
  );
}